//mutations.js for vuex store

import Vue from 'vue';
import processors from './processors.js'

/*
we declare what kind of data is coming through (Agent, Queue) with the infoType attribute.
MESSAGES SENT FROM THE SERVER WITH AN UNRECOGNIZED ATTRIBUTE WILL BE DELETED!

messages from django channels are served in json format,
format: {infoType: 'Agent', data: data}

You can dispatch messages from any component with the this.$socket.sendObj({awesome: 'data'}) method.
Remember that all socket messages MUST INCLUDE THE 'type' attribute. This declares which consumer function should
handle it on the server side.

*/


const mutations = {
	
	///queue mutations
	
	USER_ERROR(state, payload) {
		state.user.logged_in = false;
		state.user.error = true;
	},
	
	USER_LOADING(state) {
		state.user.logged_in = false;
	},
	
	USER_DATA(state, payload) {
		const logged_in = !!Object.keys(payload).length;
		state.user.logged_in = logged_in;
		state.user.data = payload;
		state.user.error = false;
		
		if (logged_in) {
			localStorage.access = payload.access;
			localStorage.refresh = payload.refresh;

			// this.$user = payload;
		}
	},
	
	
	GEOGRAPHY_DATA(state, payload) {
		state.geography.data = payload;
	},
	
	GEOGRAPHY_ERROR(state, payload) {
		state.geography.error = payload;
	},

	GLOBAL_ALERT_CREATE(state, payload){
		state.globalAlert.alert = true;
		state.globalAlert.data = payload;
	},
	
	GLOBAL_ALERT_RESET(state){
		state.globalAlert.alert = false;
		state.globalAlert.data = {};
	},

	INTRO_STATUS(state, status){
		state.introStatus.status = status;
	},

	TOGGLE_LOAD(state){
		if (state.loading){
			state.loading = false
		} else {
			state.loading = true
		}
	},

	
	
	///////
	//  WEBSOCKET HANDLING. This is wrapped into the vue-sockets plug in and called via te $socket object.
	///////
	
	
	SOCKET_ONOPEN(state, event) {
		Vue.prototype.$socket = event.currentTarget;
		state.socket.isConnected = true;
		event.currentTarget.sendObj({type:"ping", group:localStorage.parent_group}); ///we could use something from localStorage here because we are already logged in
		console.log('connection open');
		console.log(event)
	},
	
	SOCKET_ONCLOSE(state, event) {
		state.socket.isConnected = false
	},
	
	SOCKET_ONERROR(state, event) {
		//TODO: ADD SOME ERROR HANDLING, PERHAPS DEGRADE INTO REST
		console.error(state, event)
	},
	
	// default handler called for all methods
	SOCKET_ONMESSAGE(state, message) {
		console.log(message.data.message)
		state.socket.message = message.data.message;

	},
	
	// mutations for reconnect methods
	SOCKET_RECONNECT(state, count) {
		console.log("we are reconnecting now")
		console.info(state, count)
	},
	
	SOCKET_RECONNECT_ERROR(state) {
		state.socket.reconnectError = true;
	},
	
	INITIALIZE_STORE(state) {
			// Check if the ID exists



			if(localStorage.getItem('store')) {
				// Replace the state object with the stored item


				this.replaceState(
					Object.assign(state, JSON.parse(localStorage.getItem('store')))
				);

				state.loading = false
			}
		},
	
	TOGGLE_HEADER(state) {
		state.header.visible = !state.header.visible;
	},
	
	HIDE_HEADER(state) {
		state.header.visible = false;
	},
	
	SHOW_HEADER(state) {
		state.header.visible = true;
	},
	
}


export default mutations;
